import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  handleError: ['error'],
});

export { Types };
export default Creators;
